import React, { useState } from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import { PrimaryButton, Text } from 'library';
import { consoleLogInDev, track } from 'shared';
import ContentCopyIcon from 'assets/icons/content_copy.svg';
import theme from 'theme';
import WebShareLink from './WebShareLink';
import { useLocation } from 'react-router-dom';
import { useUserContext } from 'UserContext';
import { trackReferralEngagement } from 'api/UserApi';

const ReferralLink = ({
    link,
    title,
    message,
    referralContext,
}: {
    link: string;
    title: string;
    message: string;
    referralContext: string;
}) => {
    const [copyText, setCopyText] = useState('Copy');
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const shareAvailable = !!navigator.share;
    const { user } = useUserContext();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [reid, setReid] = useState<number>();

    const copyToClipboard = () => {
        setLoading(true);
        if (user) {
            trackReferralEngagement(user.id, location.pathname, `${referralContext}: Copy Link`)
                .then((response) => {
                    setReid(response.id);
                    navigator.clipboard.writeText(`${link}&reid=${response.id}`);
                })
                .catch((error) => {
                    consoleLogInDev(error);
                    navigator.clipboard.writeText(link);
                })
                .finally(() => {
                    setLoading(false);
                    setCopyText('Copied!');
                });
        }
        track('Referrals: Copy Link', { link });
    };

    return (
        <Grid style={{ padding: 20, marginBottom: 30 }}>
            <Text variant="body1" bold>
                {title}
            </Text>
            <Grid
                container
                justify={smDown ? 'flex-end' : 'space-between'}
                alignItems="flex-end"
                style={{ marginTop: 10 }}
            >
                <Grid item xs={12} md={8} style={{ marginBottom: 10 }}>
                    <Text variant="h2">{link}</Text>
                </Grid>
                <Grid
                    item
                    container
                    direction="row"
                    xs={shareAvailable ? 12 : 6}
                    md={shareAvailable ? 4 : 3}
                    justify="space-between"
                >
                    {shareAvailable ? (
                        <Grid xs={3}>
                            <WebShareLink message={message} link={!!reid ? `${link}&reid=${reid}` : link} />
                        </Grid>
                    ) : null}
                    <Grid xs={shareAvailable ? 8 : 12}>
                        <PrimaryButton onClick={copyToClipboard} loading={loading} disabled={loading}>
                            <ContentCopyIcon width={20} height={20} style={{ marginRight: 5 }} />
                            {copyText}
                        </PrimaryButton>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ReferralLink;
